import { ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material"
import { AddCircleOutlined, EditOutlined, PauseCircleOutlined } from "@mui-symbols-material/w300"

interface CompanyHeaderDropdownMenuProps {
  anchorEl: HTMLElement | null
  onClose: () => void
  isActive: boolean
  onEdit: () => void
  onDeactivate: () => void
  onActivate: () => void
  disabled?: boolean
}

const CompanyHeaderDropdownMenu: React.FC<CompanyHeaderDropdownMenuProps> = ({
  anchorEl,
  onClose,
  isActive,
  onEdit,
  onDeactivate,
  onActivate,
  disabled = false,
}) => {
  return (
    <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={onClose}>
      <MenuItem onClick={onEdit} disabled={disabled}>
        <ListItemIcon>
          <EditOutlined />
        </ListItemIcon>
        <ListItemText primary='Edit' />
      </MenuItem>
      {isActive ? (
        <MenuItem onClick={onDeactivate} disabled={disabled}>
          <ListItemIcon>
            <PauseCircleOutlined />
          </ListItemIcon>
          <ListItemText primary='Deactivate' />
        </MenuItem>
      ) : (
        <MenuItem onClick={onActivate} disabled={disabled}>
          <ListItemIcon>
            <AddCircleOutlined />
          </ListItemIcon>
          <ListItemText primary='Activate' />
        </MenuItem>
      )}
    </Menu>
  )
}

export default CompanyHeaderDropdownMenu
